import HomePage from 'sly/resourceCenter/pages/HomePage';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default HomePage;

export async function getServerSideProps() {
  const { api, store } = createApiClient(apiEndpoints);
  try {
    await Promise.all(
      [
        api.getResourceCenterMainInfo.asAction({}),
        api.getResourceCenterCommonInfo.asAction(),
        api.getTopicHeader.asAction(),
        api.getArticle.asAction({
          'filters[mainTopic][slug][$eq]': 'caregivers',
          'pagination[pageSize]': 3,
          populate: '*',
        }),
        api.getArticle.asAction({
          'filters[mainTopic][slug][$eq]': 'city-guides',
          'pagination[pageSize]': 3,
          populate: '*',
        }),
        api.getArticle.asAction({
          'filters[mainTopic][slug][$eq]': 'senior-living-guides',
          'pagination[pageSize]': 3,
          populate: '*',
        }),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
